import React from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  updateUI,
  updateBulkStateRequest,
  bulkCancelRequest,
  updateBulkSelect,
} from "../../store/actions/shipment";

function BulkCancelStateShipment() {
  const dispatch = useDispatch();
  const { isBulkCancelOpen, selectedFields } = useSelector(
    (state) => ({
      isBulkCancelOpen: state.shipment.ui.cancel.bulkCancel,
      selectedFields:
        Array.isArray(state.shipment.ui.selectedFields) &&
          state.shipment.ui.selectedFields.length > 0
          ? state.shipment.ui.selectedFields.map(
            (selectedField) => selectedField?.record?.state
          )
          : [],
    })
  );
  const handleOk = () => {
    dispatch(bulkCancelRequest());
    dispatch(
      updateUI({
        key: "cancel",
        value: {
          bulkCancel: false,
        },
      })
    );
  };
  const handleCancel = () => {
    dispatch(
      updateBulkSelect([]))
    dispatch(
        updateUI({
          key: "cancel",
          value: {
            bulkCancel: false,
          },
        })
      );
  };

  return (
    <Modal
      className="d-flex flex-column justify-content-center align-items-center p-2 bulk-shipment-edit"
      title=""
      open={isBulkCancelOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={{
        xs: "90%",
        sm: "80%",
        md: "70%",
        lg: "68%",
        xl: "65%",
        xxl: "60%",
      }}
      footer={[
        <button
          key="back"
          className="font-face-vzw cancel"
          onClick={handleCancel}
          style={{
            fontSize: "16px",
            fontWeight: 700,
          }}
        >
          No, keep
        </button>,
        <button
          key="submit"
          className="font-face-vzw update"
          onClick={handleOk}
          style={{
            fontSize: "16px",
            fontWeight: 700,
          }}
        >
          Yes, cancel
        </button>,
      ]}
    >
      <div className="py-2">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "30px",
          }}
        >
          Cancel Shipments
        </div>
      </div>
      <div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <div
            style={{
              fontWeight: 400,
              fontSize: "17px",
              fontFamily: "VerizonNHGDS",
            }}
          >
            Are you sure you want to cancel all {Array.isArray(selectedFields) ? selectedFields.length : 0} selected shipments?
          </div>
          <span
            style={{
              fontWeight: 400,
              fontSize: "17px",
              fontFamily: "VerizonNHGDS",
            }}
          >
            By cancelling the shipments, you will archive the data associated with
            the shipments.
          </span>
        </div>
      </div>
    </Modal>
  );
}

export default BulkCancelStateShipment;